import React from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Collapse from "@material-ui/core/Collapse";
import Icon from "@material-ui/core/Icon";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AddIcon from "@material-ui/icons/Add";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import * as Dati from "../../Dati";
import * as Glob from "../../Globale";
import { Trad } from "../../components/";
import useToggle from "../../hooks/Toggle";
import { SideNavIcons } from "../config/Icons";

interface ISideNavItemProps {
    Data: Dati.IDatiMenu;
    ToggleSideMenu: () => void;
}

interface IRouteParam {
    ID_Binder?: string;
    ID_Anag?: string;
}

const useStyles = makeStyles(theme => ({
    nested: {
        paddingLeft: theme.spacing(4)
    }
}));

export const _SideNavItem: React.FC<ISideNavItemProps> = ({ Data, ToggleSideMenu }) => {
    const classes = useStyles();
    const { open, toggle } = useToggle();

    const getUrl = (url: string): string => {
        const { ID_Anag = "0", ID_Binder = "0" } = useParams<IRouteParam>();
        const menu = Glob.GetMenu();

        url = url.replace("{ID_Anag}", ID_Anag);
        url = url.replace("{ID_Binder}", ID_Binder);

        if (menu && menu.VariabiliMenu) {
            for (let key in menu.VariabiliMenu) {
                const value = menu.VariabiliMenu[key];
                url = url.replace(key, value);
            }
        }

        return url;
    };

    const url = getUrl(Data.Indirizzo);
    const urlElem = url.split("/");
    const lastUrlElem = urlElem[urlElem.length - 1];
    const isAddUrlBroken = lastUrlElem.toString() == "" || Glob.IsNumeric(lastUrlElem);

    return (
        <>
            <ListItem button onClick={toggle}>
                <ListItemIcon>
                    <Icon>{SideNavIcons[Data.Icona]}</Icon>
                </ListItemIcon>
                <ListItemText primary={Trad.Trad(Data.Voce)} />
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {Glob.AzioneAbilitata(Data.ID_Funzione, Glob.Lettura) && (
                        <ListItem button component="a" href={url} onClick={ToggleSideMenu} className={classes.nested}>
                            <ListItemIcon>
                                <NavigateNextIcon />
                            </ListItemIcon>
                            <ListItemText primary={Trad.Trad("Visualizza")} />
                        </ListItem>
                    )}
                    {Glob.AzioneAbilitata(Data.ID_Funzione, Glob.Scrittura) && !isAddUrlBroken && (
                        <ListItem button component="a" href={`${url}/0`} onClick={ToggleSideMenu} className={classes.nested}>
                            <ListItemIcon>
                                <AddIcon />
                            </ListItemIcon>
                            <ListItemText primary={Trad.Trad("Inserisci")} />
                        </ListItem>
                    )}
                </List>
            </Collapse>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/SideNavItem.tsx